<template>
  <div class="rp-modal rp-omise-response" v-bind:class="{ 'is-active': isActive }"
    v-bind:style="{
      fontFamily: globalFont
    }">
    <div class="rp-modal-background"></div>
    <div class="rp-modal-content">
      <div class="rp-container-modal">
        <div
          class="rp-header-modal rp-columns is-gapless is-mobile"
          v-bind:style="{
            backgroundColor: primaryMainColor,
            color: primarySubColor
          }">
          <div class="rp-column is-2">
          </div>
          <div class="rp-page rp-column rp-helper-text-center">
            {{ t.thankYou }}
          </div>
          <div class="rp-column rp-helper-text-right is-2">
            <a v-on:click="closeModal" v-bind:style="{ color: primarySubColor }">
              <span class="is-hidden-mobile">{{ t.close }}</span>
              <span class="rp-icon">
                <i class="fa fa-times"></i>
              </span>
            </a>
          </div>
        </div>
        <div class="rp-content-modal rp-helper-text-center">
          <span class="rp-icon is-large rp-helper-text-success" v-if="orderStatus == 'successful'">
            <i class="fa fa-3x fa-check-circle"></i>
          </span>
          <span class="rp-icon is-large rp-helper-text-danger" v-else>
            <i class="fa fa-3x fa-exclamation-circle"></i>
          </span>
          <h3 v-if="orderStatus == 'successful'" class="rp-title">{{ t.successMessage }}</h3>
          <h3 v-else class="rp-helper-text-danger rp-title"><omise-messages :message="errorCode" :locale="locale"></omise-messages></h3>
          <p class="rp-helper-text-danger" v-if="orderStatus == 'error'">
            {{ t.pleaseContactMerchant }}
          </p>
          <div class="rp-card-payment-slip-container" v-if="orderStatus == 'successful'">
            <div class="rp-card-payment-slip-row">
              <span class="rp-card-payment-slip-key">{{ t.orderNumber }} : </span>
              <span class="rp-card-payment-slip-value" v-bind:style="{color: color.textPrimary}">{{orderResult.orderId}}</span>
            </div>
            <div class="rp-card-payment-slip-row">
              <span class="rp-card-payment-slip-key">{{ t.totalPrice }} : </span> 
              <span class="rp-card-payment-slip-value" v-bind:style="{color: color.textPrimary}">{{orderResult.totalPrice | productPriceFormat | currency}}</span>

            </div>
          </div>
          <button
            class="rp-button back-to-main"
            v-on:click="closeModal"
            v-bind:style="{
              backgroundColor: secondaryMainColor,
              color: secondarySubColor
            }">{{ t.back }}</button>
          <!-- <div v-html="thankYouText" class="rp-cart-text"></div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Cart } from '@/store/Cart'

import OmiseMessages from '@/components/share/OmiseMessages'

export default {
  name: 'OmiseResponse',
  components: {
    OmiseMessages
  },
  props: {
    orderStatus: {
      type: String,
      default: 'error'
    },
    orderId: {
      type: String,
      default: 'xxxxxxxxxx'
    },
    errorCode: {
      type: String,
      default: '00'
    },
    locale: {
      type: String,
      default: 'en'
    },
    primaryMainColor: {
      type: String,
      default: '#235'
    },
    primarySubColor: {
      type: String,
      default: '#efefef'
    },
    secondaryMainColor: {
      type: String,
      default: '#47e'
    },
    secondarySubColor: {
      type: String,
      default: '#efefef'
    }
  },
  data () {
    return {
      closeOmiseResponse: true
    }
  },
  computed: {
    t () {
      if (this.locale == 'en') {
        return {
          close: 'Close',
          thankYou: 'Thank You',
          back: 'Back to Main Page',
          successMessage: 'Thank you for your order.',
          pleaseContactMerchant: 'Please contact merchant then check and confirm your order again.',
          orderNumber: 'Order No.',
          totalPrice: 'Total'
        }
      } else if (this.locale == 'th') {
        return {
          close: 'ปิด',
          thankYou: 'ขอบคุณ',
          back: 'กลับสู่หน้าหลัก',
          successMessage: 'ขอบคุณสำหรับการสั่งซื้อ',
          pleaseContactMerchant: 'กรุณาติดต่อร้านค้า เพื่อตรวจสอบและยืนยันการสั่งซื้อสินค้าของท่านอีกครั้ง',
          orderNumber: 'หมายเลขการสั่งซื้อ',
          totalPrice: 'ยอดรวม'
        }
      } else if (this.locale == 'vi') {
        return {
          close: 'Đóng',
          thankYou: 'Cám ơn',
          back: 'Trở về trang chủ',
          successMessage: 'Cám ơn bạn đã đặt hàng.',
          pleaseContactMerchant: 'Vui lòng liên hệ nhà cung cấp để kiểm tra và xác đơn nhận hàng một lần nữa.',
          orderNumber: 'Order No.',
          totalPrice: 'Total'
        }
      }
    },
    isActive () {
      return this.closeOmiseResponse
    },
    globalFont () {
      return Cart.getGlobalFont()
    },
    orderResult () {
      return Cart.getOrderResult()
    },
    color () {
      let colors = {}
      let bg = '#efefef'
      if (Cart.getColorContrast(this.primaryMainColor, bg) <= 1.5) {
        if (Cart.getColorContrast(this.secondaryMainColor, bg) <= 1.5) {
          colors.textPrimary = '#000000'
        } else {
          colors.textPrimary = this.secondaryMainColor
        }
      } else {
        colors.textPrimary = this.primaryMainColor
      }
      return colors
    }
  },
  methods: {
    closeModal () {
      this.closeOmiseResponse = false
    }
  },
  filters: {
    currency (value) {
      if (value === '-' || value === 'free') {
        return Cart.t.free
      } else {
        return Cart.getCurrency(value)
      }
    },
    productPriceFormat (value) {
      if (value === '-' || value === 'free') {
        return value
      } else {
        return Cart.setNumberFormat(value)
      }
    }
  },
  mounted () {
    this.$nextTick(function () {
      Cart.getOrderDetail(this.orderId)
    })
  }
}
</script>

<style lang="scss" scoped>
// @import "~@/scss/custom.scss";
.rp-omise-response {
  .rp-modal-content {
    max-width: none !important;
    width: 100%;
    height: calc(100vh - 160px);
    max-height: calc(100vh - 160px);
    .rp-container-modal {
      overflow: hidden;
      background-color: #efefef;
      margin: 0 auto;
      height: 100%;
      .rp-header-modal {
        margin-bottom: 0;
        padding: 15px;
        background-color: #235;
        // background-color: $primary;
        .rp-page {line-height: 25px;}
      }
      .rp-content-modal {
        background-color: #efefef;
        padding: 1.5em;
        overflow: auto;
        height: calc(100% - 55px - 1.5em);
        .back-to-main {
          margin-top: 25px;
          padding: 0px 25px;
          border-radius: 10px;
        }

        .rp-icon {
          margin: 20px;
        }
      }
    }
  }
}
.rp-card-payment-slip-row {
  button {
    padding-bottom: 0;
    padding-top: 0;
    border-radius: 10px;
    background-color: #2196f3;
    color: white;
    justify-content: center;
  }
}
@media screen and (max-width: 768px) {
  .rp-omise-response {
    padding: 0;
    .rp-modal-content{
      margin:0;
      background-color: #efefef;
      height: 100%;
      max-height: none;
      .rp-container-modal {
        width: 100%;
      }
    }
  }
}

@media screen and (min-width: 769px) and (max-width: 1023px) {
  .rp-omise-response {
    .rp-container-modal {
      width: 728px;
    }
  }
}

@media screen and (min-width: 1024px){
  .rp-omise-response {
    .rp-container-modal {
      width: 984px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/OmiseResponse.vue